<form *ngIf="form" [formGroup]="form.control" (ngSubmit)="onSubmit()">
  <h1 mat-dialog-title>
    {{ title }} refund option
  </h1>

  <div mat-dialog-content>

    <div *ngIf="refundInfo$ | async; let refundInfo">
      <ul>
        <li *ngIf="refundInfo.paid">Amount already paid: {{ refundInfo.paid | currency: refundInfo.currency }}</li>
        <li *ngIf="refundInfo.paid">Amount to be refunded: {{ refundInfo.toRefund | currency: refundInfo.currency }}</li>
        <li *ngIf="refundInfo.paid === 0">Payment request to be cancelled: {{ refundInfo.toRefund | currency: refundInfo.currency }}</li>
      </ul>
    </div>

    <eas-easform-group [easGroup]="form">
    </eas-easform-group>
  </div>

  <div mat-dialog-actions>
    <ub-button-list>
      <button mat-flat-button
              type="button"
              color="warn"
              [mat-dialog-close]="canceled">Cancel</button>
      <button mat-flat-button
              type="submit"
              color="primary"
              [mat-dialog-close]="true"
              cdkFocusInitial>{{ title }}</button>
    </ub-button-list>
  </div>
</form>